import { useLocation } from "@reach/router";
import { useMemo } from "react";

/** Hook that gets page's query parameters */
export const useQueryParams = () => {
  const location = useLocation();

  return useMemo(() => new URLSearchParams(location.search), [location.search]);
};
